const BASE_URL = "https://api.shubhamraj01.in";

const getHeaders = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

export const createRazorpayOrder = async (orderId) => {
  const res = await fetch(`${BASE_URL}/api/payment/razorpay/${orderId}`, {
    method: "POST",
    headers: getHeaders(),
  });
  if (!res.ok) throw new Error("Razorpay order create failed");
  return res.json();
};

export const verifyRazorpayPayment = async (data) => {
  const res = await fetch(`${BASE_URL}/api/payment/razorpay/verify`, {
    method: "POST",
    headers: getHeaders(),
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error("Payment verification failed");
  return res.json();
};

export const createCodPayment = async (orderId) => {
  const res = await fetch(`${BASE_URL}/api/payment/cod/${orderId}`, {
    method: "POST",
    headers: getHeaders(),
  });
  if (!res.ok) throw new Error("COD payment failed");
  return res.json();
};

export const getPaymentStatus = async (orderId) => {
  const res = await fetch(`${BASE_URL}/api/payment/${orderId}`, {
    headers: getHeaders(),
  });
  if (!res.ok) throw new Error("Payment status fetch failed");
  return res.json();
};